var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{attrs:{"bg-class":"tw-bg-yellow-800","text-class":"tw-text-white","rounded":_vm.rounded}},[_vm._v("\n  "+_vm._s(_vm.isPaid ? _vm.$t('paid classified::pliromeni') : _vm.$t('paid classified'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }